import '../../../../../node_modules/@glidejs/glide/dist/css/glide.core.css'
import Glide from '@glidejs/glide'

const homeSlider = {
  el: '',
  init() {
    this.el = $q('.homeslider')

    if (!this.el.first) return

    new Glide(this.el.first, {
      autoplay: 5000
    }).mount()
  }
}
export default homeSlider
